(function () {
  'use strict';

  // ── Quantity Selector ──────────────────────────────────────────────────

  function findProductForms(variantId) {
    return Array.from(document.querySelectorAll('product-form')).filter(function (form) {
      var input = form.querySelector('input[name="id"]');
      return input && input.value === String(variantId);
    });
  }

  function transformToQty(productForm, variantId, qty, key) {
    if (productForm.querySelector('.ct-qty-selector')) {
      updateQtyDisplay(productForm, qty);
      // Also update the key in case it changed
      var existingSelector = productForm.querySelector('.ct-qty-selector');
      if (existingSelector && key) existingSelector.dataset.key = key;
      return;
    }
    var submitBtn = productForm.querySelector('[type="submit"]');
    var buttonsContainer = productForm.querySelector('.product-form__buttons');

    // Read computed styles before hiding so we match the button exactly.
    // We intentionally skip `color` because .button.loading sets color:transparent,
    // which would make the −/1/+ invisible. Color is inherited from context instead.
    var computedBg = null;
    var computedBorder = null;
    var computedRadius = null;
    if (submitBtn) {
      var s = window.getComputedStyle(submitBtn);
      computedBg = s.backgroundColor;
      computedBorder = s.border;
      computedRadius = s.borderRadius;
      submitBtn.style.display = 'none';
    }


    var selector = document.createElement('div');
    selector.className = 'ct-qty-selector';
    selector.dataset.variantId = String(variantId);
    if (key) selector.dataset.key = key;

    if (!buttonsContainer) selector.style.height = '35px';
    if (computedBg) selector.style.backgroundColor = computedBg;
    if (computedBorder) selector.style.border = computedBorder;
    if (computedRadius) selector.style.borderRadius = computedRadius;

    selector.innerHTML =
      '<button class="ct-qty-selector__btn ct-qty-btn-minus" type="button">&#8722;</button>' +
      '<span class="ct-qty-selector__count">' + qty + '</span>' +
      '<button class="ct-qty-selector__btn ct-qty-btn-plus" type="button">+</button>';

    // Append inside the fixed sticky bar when present (PDP), else append to productForm (cards)
    (buttonsContainer || productForm).appendChild(selector);
  }

  function revertToAtc(productForm) {
    var selector = productForm.querySelector('.ct-qty-selector');
    if (selector) selector.remove();
    var submitBtn = productForm.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.style.display = '';
  }

  function updateQtyDisplay(productForm, qty) {
    var el = productForm.querySelector('.ct-qty-selector__count');
    if (el) el.textContent = qty;
  }

  // ── Gift Add / Removal ─────────────────────────────────────────────────
  // The gift is added once the cart total reaches ₹999 and removed when it drops
  // below. This file is the single implementation: it is driven by the global
  // cart-mutation hook further down, so the gift follows the cart total no matter
  // which path changed it.
  //
  // Two cart attributes track state across requests, both cleared once the total
  // drops below the threshold so the next crossing starts clean:
  //   id            — the gift variant ID, written only after a successful add
  //   gift_declined — set when the shopper deletes the pouch while still eligible,
  //                   so it is offered once and not forced back into the cart

  var GIFT_VARIANT_ID = '47243158683970';
  var GIFT_THRESHOLD = 99900; // ₹999 in paise
  var GIFT_DECLINED_ATTR = 'gift_declined';

  // Prevents concurrent gift add/remove requests from racing (e.g. fast +/-
  // clicks crossing the threshold), which could double-add or mis-tag the gift.
  var giftBusy = false;

  // The minis are removed independently of the pouch (they run concurrently in
  // syncGift), so they need their own in-flight flag rather than sharing one.
  var minisBusy = false;

  // Toggles the cart drawer's loading overlay. Shown while the gift is being
  // added/removed so the qty +/- path matches the drawer's own qty change UX.
  function toggleDrawerLoader(show) {
    document.querySelectorAll('.loader-main').forEach(function (el) {
      el.style.display = show ? 'flex' : 'none';
    });
  }

  // Is the gift line actually in the cart? Never infer this from the attributes —
  // they are only markers, and a cart can be tagged with the line absent.
  function isGiftInCart(parsedState) {
    return !!(parsedState.items && parsedState.items.some(function (item) {
      return String(item.variant_id) === GIFT_VARIANT_ID;
    }));
  }

  // Set only after the pouch has actually been added, so "given but not in the
  // cart" can only mean the shopper deleted the line themselves.
  function wasGiftGiven(parsedState) {
    return !!(parsedState.attributes && String(parsedState.attributes.id) === GIFT_VARIANT_ID);
  }

  // Remembers that deletion, so the pouch is not silently re-added on every later
  // cart change. Both markers reset once the total drops below the threshold.
  function isGiftDeclined(parsedState) {
    return !!(parsedState.attributes && parsedState.attributes[GIFT_DECLINED_ATTR]);
  }

  function updateCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  // Synchronous check: will syncGift actually add or remove a cart line for this
  // state? Lets callers decide whether to show a loader (avoids a no-op flash).
  // Marker-only writes deliberately return false — nothing visible changes.
  function giftWillChange(parsedState) {
    if (!minisBusy && forfeitedMiniKeys(parsedState).length) return true;
    if (giftBusy) return false;
    if (parsedState.total_price >= GIFT_THRESHOLD) {
      if (isGiftInCart(parsedState)) return false;
      return !wasGiftGiven(parsedState) && !isGiftDeclined(parsedState);
    }
    return isGiftInCart(parsedState);
  }

  function addGiftIfAboveThreshold(parsedState) {
    if (giftBusy) return Promise.resolve();
    if (parsedState.total_price < GIFT_THRESHOLD) return Promise.resolve();
    if (isGiftInCart(parsedState)) return Promise.resolve();

    // Given earlier but gone now — the shopper deleted it. Record that and leave
    // the cart alone; re-adding here is what produced the add/delete loop.
    if (wasGiftGiven(parsedState)) return declineGift();

    // Already declined for this eligibility run — respect it.
    if (isGiftDeclined(parsedState)) return Promise.resolve();

    giftBusy = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (addResponse) {
        updateCartSections(addResponse);
        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl) cartDrawerEl.classList.remove('is-empty');
        // Tag after the add succeeds, never before: a failed add must not leave the
        // cart looking like the gift was given and then deleted.
        return updateCartAttributes({ id: GIFT_VARIANT_ID }).catch(function () {});
      })
      .catch(function () {})
      .finally(function () { giftBusy = false; });
  }

  // Records that the shopper does not want the pouch, so it is not offered again
  // until the total drops below the threshold and the markers reset.
  //
  // giftBusy is raised synchronously, before the write goes out: the deletion the
  // shopper just made triggers its own reconciliation pass, and without this the
  // pass could read the cart before the attribute lands and re-add the pouch.
  function declinedAttributes() {
    var declined = { id: '' };
    declined[GIFT_DECLINED_ATTR] = '1';
    return declined;
  }

  function declineGift() {
    giftBusy = true;
    return updateCartAttributes(declinedAttributes())
      .catch(function () {})
      .finally(function () { giftBusy = false; });
  }

  // Undoes declineGift when the shopper clicks "Add back" on the drawer's faded
  // pouch row. Same order as addGiftIfAboveThreshold: the markers are written only
  // after the add succeeds, so a failed add leaves the decline in place.
  function restoreGift() {
    if (giftBusy) return Promise.resolve();
    giftBusy = true;
    toggleDrawerLoader(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (addResponse) {
        if (addResponse.status) return;
        updateCartSections(addResponse);
        var restored = { id: GIFT_VARIANT_ID };
        restored[GIFT_DECLINED_ATTR] = '';
        return updateCartAttributes(restored).catch(function () {});
      })
      .catch(function () {})
      .finally(function () {
        giftBusy = false;
        toggleDrawerLoader(false);
      });
  }

  function removeGiftIfBelowThreshold(parsedState) {
    if (giftBusy) return Promise.resolve();
    if (parsedState.total_price >= GIFT_THRESHOLD) return Promise.resolve();

    // Find the pouch by its variant ID, not via the attributes — the marker can be
    // missing while the line is present.
    var giftItem = parsedState.items && parsedState.items.find(function (item) {
      return String(item.variant_id) === GIFT_VARIANT_ID;
    });
    var needsMarkerReset = wasGiftGiven(parsedState) || isGiftDeclined(parsedState);
    if (!giftItem && !needsMarkerReset) return Promise.resolve();

    var cleared = { id: '' };
    cleared[GIFT_DECLINED_ATTR] = '';

    giftBusy = true;

    // No line to pull, just stale markers: reset them so crossing the threshold
    // again offers the gift afresh instead of being permanently suppressed.
    if (!giftItem) {
      return updateCartAttributes(cleared)
        .catch(function () {})
        .finally(function () { giftBusy = false; });
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftItem.key, quantity: 0, sections: ['cart-drawer', 'cart-icon-bubble'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (updatedState) {
        updateCartSections(updatedState);
        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl) {
          cartDrawerEl.classList.toggle('is-empty', updatedState.item_count === 0);
        }
        return updateCartAttributes(cleared).catch(function () {});
      })
      .catch(function () {})
      .finally(function () { giftBusy = false; });
  }

  // Safety net for the free minis. The drawer's own remove path folds forfeited
  // freebies into the request that strands them, so this normally no-ops — it
  // exists for the mutations that never go through cart.js (HairGPT widget, quiz,
  // PDP forms), which is the same reason the pouch is reconciled here.
  //
  // The pouch is skipped: removeGiftIfBelowThreshold already owns it, including
  // the attribute bookkeeping that decides whether it is offered again.
  //
  // It also trims an over-claim. The Claim buttons live in a server-rendered
  // block that only prints while the cart holds fewer than the allowance, so the
  // gate is the *previous* render: clicking several Claim buttons before that
  // render lands fires several adds against the same stale state and the cart
  // ends up with three or more minis. Capping here catches every such race,
  // whichever path made the adds.
  function removeForfeitedMinis(parsedState) {
    if (minisBusy) return Promise.resolve();
    if (!window.CartFreebies) return Promise.resolve();

    var updates = {};
    forfeitedMiniKeys(parsedState).forEach(function (key) { updates[key] = 0; });

    if (window.CartFreebies.cappedMiniUpdates) {
      var capped = window.CartFreebies.cappedMiniUpdates(parsedState);
      Object.keys(capped).forEach(function (key) {
        // A forfeit already zeroes the line; never raise it back to the cap.
        if (!(key in updates)) updates[key] = capped[key];
      });
    }

    if (!Object.keys(updates).length) return Promise.resolve();

    minisBusy = true;

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: ['cart-drawer', 'cart-icon-bubble'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (updatedState) {
        updateCartSections(updatedState);
        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl) {
          cartDrawerEl.classList.toggle('is-empty', updatedState.item_count === 0);
        }
      })
      .catch(function () {})
      .finally(function () { minisBusy = false; });
  }

  function forfeitedMiniKeys(parsedState) {
    if (!window.CartFreebies) return [];

    return window.CartFreebies.forfeitedKeysFrom(parsedState).filter(function (key) {
      var item = (parsedState.items || []).find(function (i) { return i.key === key; });
      return item && String(item.variant_id) !== GIFT_VARIANT_ID;
    });
  }

  // Single entry point used by every cart-mutation path (qty +/-, mobile media
  // modal). add/remove are mutually exclusive by threshold, so one always no-ops.
  // Returns a Promise that resolves once the gift add/remove (if any) completes.
  function syncGift(parsedState) {
    return Promise.all([
      addGiftIfAboveThreshold(parsedState),
      removeGiftIfBelowThreshold(parsedState),
      removeForfeitedMinis(parsedState)
    ]);
  }

  // Exposed so product-modal-mobile.js (a separate IIFE) reuses the exact same
  // gift logic instead of duplicating it.
  window.ctSyncGift = syncGift;
  // Called by the cart's remove handler the moment the pouch line is deleted.
  // Inferring the decline afterwards from the `id` marker is not enough: whenever
  // that marker is missing the deletion is indistinguishable from "never given",
  // and the pouch is re-added straight away.
  window.ctDeclineGift = declineGift;
  // The same markers as an object, so the drawer's remove request can carry them and
  // render the "Add back" row in its own response (see without-sale-cart.js).
  window.ctGiftDeclinedAttributes = declinedAttributes;
  // Called by the "Add back" button on the drawer's faded pouch row.
  window.ctRestoreGift = restoreGift;
  window.ctGiftWillChange = giftWillChange;

  // ── Global Cart Mutation Hook ──────────────────────────────────────────
  // The gift used to be re-implemented inside each UI handler that could change
  // the cart (product form submit, drawer qty, qty selector, quiz), so any add
  // that bypassed those handlers never got it — notably the HairGPT chat widget,
  // which POSTs straight to /cart/add.js. Hooking the fetch layer instead means
  // one implementation covers every path, including third-party ones.
  //
  // nativeFetch is captured before wrapping so syncGift's own requests can be
  // told apart: they re-enter this wrapper, and the running/queued pair collapses
  // them into at most one extra reconciliation pass instead of looping.

  var nativeFetch = window.fetch;
  var giftSyncRunning = false;
  var giftSyncQueued = false;

  function syncGiftFromServer() {
    if (giftSyncRunning) {
      giftSyncQueued = true;
      return;
    }
    giftSyncRunning = true;
    // Holds checkout closed across the whole reconciliation, not just the write:
    // the gift decision needs the fresh /cart.js read before it is safe to pay.
    if (window.CartBusy) window.CartBusy.begin();

    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var showLoader = giftWillChange(cart);
        if (showLoader) toggleDrawerLoader(true);
        return syncGift(cart).then(function () {
          if (showLoader) toggleDrawerLoader(false);
        });
      })
      .catch(function () {})
      .then(function () {
        giftSyncRunning = false;
        if (window.CartBusy) window.CartBusy.end();
        if (giftSyncQueued) {
          giftSyncQueued = false;
          syncGiftFromServer();
        }
      });
  }

  window.fetch = function () {
    var url = arguments[0];
    url = (typeof url === 'string') ? url : (url && url.url) || '';
    var result = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)/.test(url)) {
      // Busy from the moment the write leaves, not from when it answers. The
      // gap between the two is what lets a second Claim click reach the server
      // while the drawer still shows the pre-add state.
      if (window.CartBusy) window.CartBusy.begin();
      result
        .then(function () { syncGiftFromServer(); })
        .catch(function () {})
        .then(function () { if (window.CartBusy) window.CartBusy.end(); });
    }
    return result;
  };

  // ── Cart Section Update ────────────────────────────────────────────────
  // Mirrors CartDrawerItems.getSectionsToRender() in cart-drawer.js

  function updateCartSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    function replaceSection(elementId, sectionKey, selector) {
      var el = document.getElementById(elementId);
      if (!el) return;
      var html = parsedState.sections[sectionKey];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = doc.querySelector(selector);
      var dest = el.querySelector(selector) || el;
      if (source) dest.innerHTML = source.innerHTML;
    }

    replaceSection('CartDrawer', 'cart-drawer', '.drawer__inner');
    replaceSection('cart-icon-bubble', 'cart-icon-bubble', '.shopify-section');
  }

  // ── Cart API ───────────────────────────────────────────────────────────

  function changeCartQty(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: ['cart-drawer', 'cart-icon-bubble'] })
    }).then(function (r) { return r.json(); });
  }

  // ── Sync All Qty Selectors with Cart State ─────────────────────────────

  // Last known cart, kept so a variant change can repaint the qty selectors
  // immediately instead of waiting on /cart.js. Every cart mutation path already
  // triggers a sync, so this stays current; the fetch below still corrects it.
  var lastCart = null;

  function syncQtySelectorsFromCache() {
    if (lastCart) applyCartToSelectors(lastCart);
  }

  function syncAllQtySelectors() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        lastCart = cart;
        applyCartToSelectors(cart);
      })
      .catch(function () {});
  }

  function applyCartToSelectors(cart) {
    var cartItemsByVariant = {};
    cart.items.forEach(function (item) {
      cartItemsByVariant[String(item.variant_id)] = item;
    });

    // Update or revert existing qty selectors
    document.querySelectorAll('.ct-qty-selector').forEach(function (selector) {
      var variantId = selector.dataset.variantId;
      var productForm = selector.closest('product-form');
      if (!productForm) return;

      // The PDP variant picker rewrites input[name="id"] in place, so a
      // selector can be left over from a previously selected variant. Its
      // −/+ still carries that variant's line-item key and would edit the
      // wrong line, so drop it and let the pass below rebuild one if the
      // newly selected variant is itself in the cart.
      var currentInput = productForm.querySelector('input[name="id"]');
      if (currentInput && currentInput.value !== variantId) {
        revertToAtc(productForm);
        return;
      }

      var cartItem = cartItemsByVariant[variantId];
      if (!cartItem) {
        revertToAtc(productForm);
      } else {
        if (cartItem.key) selector.dataset.key = cartItem.key;
        updateQtyDisplay(productForm, cartItem.quantity);
      }
    });

    // Add qty selectors for items in cart that have no selector yet
    cart.items.forEach(function (item) {
      findProductForms(item.variant_id).forEach(function (form) {
        if (!form.querySelector('.ct-qty-selector')) {
          transformToQty(form, item.variant_id, item.quantity, item.key);
        }
      });
    });
  }

  // ── Cart Drawer State ──────────────────────────────────────────────────

  function isCartDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    return drawer && drawer.classList.contains('active');
  }

  // ── ATC Success Listener ───────────────────────────────────────────────

  document.addEventListener('ct:atc-success', function (e) {
    var variantId = e.detail.variantId;
    var imageUrl = e.detail.imageUrl;

    // Synchronously hide the ATC button before product-form.js .finally()
    // re-shows it — prevents the brief "Add to cart" flicker between loader
    // dismissal and the async /cart.js fetch resolving.
    findProductForms(variantId).forEach(function (form) {
      transformToQty(form, variantId, 1, String(variantId));
    });

    var drawer = document.querySelector('cart-drawer');
    if (drawer && !isCartDrawerOpen()) drawer.open();

    // Fetch /cart.js only to resolve the real key and qty for the selector.
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartItem = cart.items.find(function (item) {
          return String(item.variant_id) === String(variantId);
        });
        var qty = cartItem ? cartItem.quantity : 1;
        var key = cartItem ? cartItem.key : String(variantId);

        findProductForms(variantId).forEach(function (form) {
          transformToQty(form, variantId, qty, key);
        });
      })
      .catch(function () {});
  });

  // ── Cart Drawer Qty Change Sync ────────────────────────────────────────
  // 'cart-update' is published by CartItems (cart.js) after drawer +/- changes

  document.addEventListener('cart-update', function () {
    syncAllQtySelectors();
  });

  // ── Qty +/- Click (delegated) ──────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.ct-qty-selector__btn') : null;
    if (!btn) return;

    var selector = btn.closest('.ct-qty-selector');
    var productForm = btn.closest('product-form');
    if (!selector || !productForm) return;

    var key = selector.dataset.key || selector.dataset.variantId;
    var variantId = selector.dataset.variantId;
    var countEl = selector.querySelector('.ct-qty-selector__count');
    var currentQty = parseInt(countEl ? countEl.textContent : '1', 10);
    var isMinus = btn.classList.contains('ct-qty-btn-minus');
    var newQty = isMinus ? currentQty - 1 : currentQty + 1;

    selector.classList.add('ct-qty-selector--loading');
    selector.querySelectorAll('.ct-qty-selector__btn').forEach(function (b) { b.disabled = true; });

    changeCartQty(key, newQty)
      .then(function (parsedState) {
        updateCartSections(parsedState);
        // Mirror without-sale-cart.js: the empty-state markup is only shown when
        // cart-drawer has the .is-empty class (see component-cart-drawer.css).
        // Without this, emptying the cart from a card leaves the drawer blank.
        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl) cartDrawerEl.classList.toggle('is-empty', parsedState.item_count === 0);
        selector.classList.remove('ct-qty-selector--loading');
        if (newQty <= 0) {
          findProductForms(variantId).forEach(function (form) { revertToAtc(form); });
        } else {
          findProductForms(variantId).forEach(function (form) { updateQtyDisplay(form, newQty); });
          selector.querySelectorAll('.ct-qty-selector__btn').forEach(function (b) { b.disabled = false; });
          if (!isMinus) {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && !isCartDrawerOpen()) drawer.open();
          }
        }
        // Gift sync is not called here: changeCartQty's /cart/change.js request
        // already goes through the global cart-mutation hook above.
      })
      .catch(function () {
        selector.classList.remove('ct-qty-selector--loading');
        selector.querySelectorAll('.ct-qty-selector__btn').forEach(function (b) { b.disabled = false; });
      });
  });

  // ── Page Load: Restore + Observe ──────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    // Restore qty selectors for items already in cart
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Seeds the cache the variant-change path repaints from. Without this it
        // stays null until the first cart mutation, so the very first variant
        // switch on a page had nothing to repaint from and still waited on the
        // /cart.js round trip to swap between the qty selector and the ATC button.
        lastCart = cart;
        cart.items.forEach(function (item) {
          findProductForms(item.variant_id).forEach(function (form) {
            transformToQty(form, item.variant_id, item.quantity, item.key);
          });
        });
      })
      .catch(function () {});

    // Primary catch-all: cart-icon-bubble is updated by every cart mutation path
    // (ATC, drawer +/-, GokWik, etc.) so observing it is more reliable than any single event
    var syncTimer = null;
    function debouncedSync() {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(syncAllQtySelectors, 150);
    }

    var cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble) {
      new MutationObserver(debouncedSync).observe(cartIconBubble, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Sync when the cart drawer re-renders its contents. Opening the drawer
    // refetches /?sections=cart-drawer and replaces #CartDrawer's innerHTML
    // (cart-drawer.js), which wipes the qty selectors we built on load and
    // restores the server-rendered ATC buttons. That open path doesn't touch
    // cart-icon-bubble, so the observer above never fires for it — re-sync here.
    // childList only (no subtree) so our own deep selector mutations inside the
    // upsell cards don't retrigger this observer.
    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      new MutationObserver(function (mutations) {
        var hasNew = mutations.some(function (m) { return m.addedNodes.length > 0; });
        if (hasNew) debouncedSync();
      }).observe(cartDrawer, { childList: true });
    }

    // Sync when load-more appends new product cards to the grid
    var productGrid = document.getElementById('product-grid');
    if (productGrid) {
      new MutationObserver(function (mutations) {
        var hasNew = mutations.some(function (m) { return m.addedNodes.length > 0; });
        if (hasNew) debouncedSync();
      }).observe(productGrid, { childList: true });
    }

    // Sync when the PDP variant changes. Whether a variant is in the cart is
    // per variant, so switching size must swap between the qty selector and the
    // ATC button. global.js updateVariantInput() rewrites input[name="id"] and
    // dispatches a bubbling change event, which is the hook used here.
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.tagName !== 'INPUT' || input.name !== 'id') return;
      if (!input.closest('product-form')) return;
      // Repaint from the known cart first so the switch between the qty selector
      // and the ATC button is immediate, then confirm against the server. The
      // debounce exists to collapse bursts of cart mutations; a variant click is
      // a single deliberate action, so waiting on it only adds lag.
      syncQtySelectorsFromCache();
      syncAllQtySelectors();
    });

    // Fallback: sync when returning to tab after changes in another tab
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) syncAllQtySelectors();
    });

  });

})();
